'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileExtensionIsBlacklisted = undefined;

var _blacklistedExtensions = require('conversations-schema/file-metadata/constants/blacklistedExtensions');

var fileExtensionIsBlacklisted = exports.fileExtensionIsBlacklisted = function fileExtensionIsBlacklisted(file) {
  var fileNameParts = file.name.split('.');
  var fileExtension = fileNameParts[fileNameParts.length - 1] || '';
  var lowercaseExtension = fileExtension.toLowerCase();

  return _blacklistedExtensions.blacklistedExtensions.some(function (extension) {
    return lowercaseExtension === extension;
  });
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/util/fileExtensionIsBlacklisted.js
// module id = 557
// module chunks = 2 3